<template>
  <div class="u-full-vp-height">
    <div class="u-wrapper-panel">
      <video-player :forcePlay="true" :isStoppable="false" src="/videos/logo.mp4" poster="/images/prisme7--mobile.png" />
      <!-- <img class="u-full-width" :src="$device.isMobile || $device.isTablet ? '/images/prisme7--mobile.png' : '/images/prisme7.png'"> -->
      <div class="header__gradient u-wrapper-panel"></div>
    </div>
    <div class="u-wrapper-panel">
      <div class="u-row u-top u-full-height">
        <div class="u-w1of12 u-pad-x-md u-pad-t-md u-marg-t-md u-none--sm">
          <div class="u-relative">
            <img class="header__pompidou-large u-full-width" alt="pompidou" src="/images/pompidou.png">
          </div>
        </div>
        <div v-if="$device.isMobile || $device.isTablet" class="u-none u-block--sm u-full-width u-marg-t-md u-row u-center">
          <img class="u-w5of12--xs u-w3of12" alt="pompidou" src="/images/pompidou-big.png">
        </div>
        <div class="header__socials u-w10of12 u-marg-l-0--sm u-w12of12--sm u-marg-t-md--sm u-relative u-flex u-bottom u-full-height">
          <div class="u-row u-full-width u-center u-marg-b-md u-marg-sm--xs">
            <template  v-for="platform in platforms" >
              <a v-if="platform.name !== 'windows'" :href="platform.url" target="_blank" class="u-w2of12 u-w4of12--sm u-w7of12--xs u-marg-t-sm--xs u-block u-block u-pad-x-sm">
                <anim-scroll class="u-full-width" :margin="0" :isStagger="true" :delay="3000">
                  <img class="u-full-width" :alt="platform.name" :src="`/images/${platform.name}.png`">
                </anim-scroll>
              </a>
              <a v-else :href="platform.url" download="prisme7.zip" @click="$ga.send('download', 'microsoft')" class="u-w2of12 u-w4of12--sm u-w7of12--xs u-marg-t-sm--xs u-block u-block u-pad-x-sm">
                <anim-scroll class="u-full-width" :margin="0" :isStagger="true" :delay="3000">
                  <img class="u-full-width" :alt="platform.name" :src="`/images/${platform.name}.png`">
                </anim-scroll>
              </a>
            </template>
          </div>
        </div>
        <div class="u-w1of12 u-relative u-pad-t-md u-none--sm">
          <img class="header__pompidou u-full-width" alt="pompidou" src="/images/pompidou-2.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/components/common/VideoPlayer'
import AnimScroll from '@/components/common/AnimScroll'

export default {
  props: {
    platforms: {
      type: Array,
      required: true
    }
  },

  components: {
    VideoPlayer,
    AnimScroll
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/settings/variables'
@import '~@/styles/settings/mixins/mq'

.header
  &__gradient
    background linear-gradient(to top, $colors.grey, transparent 20%, transparent)

  &__socials
    +mq($until: 'tablet')
      position absolute
      bottom 0
      left 0
  
  &__pompidou
    transform translateX(-50%)
  
  &__pompidou-large 
    max-width 70px
    position fixed
    z-index 1
    left 10px

</style>